module.exports = __webpack_public_path__ + "img/loading.a1bde3d9.gif";